<template>
  <div>
    <div class="containerFull" style="min-height:600px">
      <div class="p-grid">
        <div class="p-col-12">
          <h2 style="border-bottom: 1px solid #cfcfcf;" class="p-pb-5 p-mt-6 titulo-admin p-ml-2">
            Listado de Especialidades
          </h2>
          <DataTable ref="dt" :value="especialidades" dataKey="id" :paginator="true" :rows="10" :filters="filters"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :rowsPerPageOptions="[5, 10, 25]"
            currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} especialidades"
            class="p-datatable-responsive-demo p-mt-5" style="margin-bottom:100px" :loading="loading">
            <template #header>
              <div class="table-header" style="align-items: center;display: flex;">
                <Button icon="pi pi-plus" class="p-button-rounded p-button-info p-mr-3" @click="openNew"
                  :disabled="loading" v-tooltip.rigth="'Agregar nuevo'" name="nuevo" />
                <span class="p-input-icon-left" style="margin-left: auto;">
                  <i class="pi pi-search" />
                  <InputText v-model="filters['global']" placeholder="Buscar..." />
                </span>
              </div>
            </template>
            <Column field="nombre" header="Nombre" :sortable="true">
              <template #body="slotProps">
                <span class="p-column-title">Nombre</span>
                {{ slotProps.data.nombre }}
              </template>
            </Column>
            <Column field="descripcion" header="Descripción" :sortable="true"><template #body="slotProps">
                <span class="p-column-title">Descripción</span>
                {{ slotProps.data.descripcion }}
              </template></Column>
            <Column field="orden" header="Orden en listado" :sortable="true"><template #body="slotProps">
                <span class="p-column-title">Orden en listado</span>
                {{ slotProps.data.orden }}
              </template></Column>
            <Column field="ocultar_en_listado" header="Oculta en listado" :sortable="true"><template #body="slotProps">
                <span class="p-column-title">Oculta en listado</span>
                {{ slotProps.data.ocultar_en_listado ? "Si" : "No" }}
              </template></Column>
            <Column :exportable="false">
              <template #body="slotProps">
                <span class="p-column-title">Acciones</span>
                <Button icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                  @click="editEspecialidad(slotProps.data)" v-tooltip.top="'Editar'" name="editar" />
                <Button icon="pi pi-trash" class="p-button-rounded p-button-warning p-mr-2"
                  @click="confirmDeleteEspecialidad(slotProps.data)" v-tooltip.top="'Eliminar'" name="eliminar" />
                <Button icon="pi pi-eye" class="p-button-rounded p-button-warning p-mr-2"
                  @click="toggleEnListado(slotProps.data, 0)" v-tooltip.top="'Mostrar en listado'" name="mostrar"
                  v-if="slotProps.data.ocultar_en_listado" />
                <Button icon="pi pi-eye-slash" class="p-button-rounded p-button-warning"
                  @click="toggleEnListado(slotProps.data, 1)" v-tooltip.top="'Ocultar en listado'" name="ocultar"
                  v-if="!slotProps.data.ocultar_en_listado" />
              </template>
            </Column>
          </DataTable>

          <Dialog :closable="false" :visible="especialidadDialog" :style="{ width: '450px' }"
            header="Detalles de la Especialidad" :modal="true" class="p-fluid" :contentStyle="{ overflow: 'visible' }">
            <div class="p-grid">
              <div class="p-field p-col-12">
                <label for="nombre">Nombre</label>
                <InputText id="nombre" v-model.trim="especialidad.nombre" required="true" autofocus
                  :class="{ 'p-invalid': submitted && !especialidad.nombre }" />
                <small class="p-invalid" v-if="submitted && !especialidad.nombre">El campo es requerido</small>
              </div>
              <div class="p-field p-col-12">
                <label for="descripcion">Descripción</label>
                <InputText id="descripcion" v-model.trim="especialidad.descripcion" required="true" autofocus :class="{
                  'p-invalid': submitted && !especialidad.descripcion,
                }" maxlength="200" />
                <small class="p-invalid" v-if="submitted && !especialidad.descripcion">El campo es requerido</small>
              </div>
              <div class="p-field p-col-12">
                <label for="orden">Orden en listado</label>
                <InputText id="orden" v-model.trim="especialidad.orden" required="true" autofocus :class="{
                  'p-invalid': submitted && !especialidad.orden,
                }" />
                <small class="p-invalid" v-if="submitted && !especialidad.orden">El campo es requerido</small>
              </div>
            </div>
            <template #footer>
              <Button label="Cancelar" icon="pi pi-times" class="p-button-text" @click="hideDialog" name="cancelar" />
              <Button label="Guardar" icon="pi pi-check" class="p-button-text" @click="saveEspecialidad"
                :disabled="loading" name="aceptar" />
            </template>
          </Dialog>
          <Dialog :visible="deleteEspecialidadDialog" :style="{ width: '450px' }" header="Confirmación de eliminación"
            :modal="true">
            <div class="confirmation-content">
              <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
              <span v-if="especialidad">Esta seguro que desea eliminar el especialidad
                <b>{{ especialidad.nombre }}</b>?</span>
            </div>
            <template #footer>
              <Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteEspecialidadDialog = false"
                name="cancelar" />
              <Button label="Si" icon="pi pi-check" class="p-button-text" @click="deleteEspecialidad" name="aceptar" />
            </template>
          </Dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EspecialidadesService from "../service/especialidades.service";
export default {
  metaInfo: {
    title: 'Backoffice - QualityCare',
    htmlAttrs: {
      lang: 'es',
    },
    meta: [
      {
        name: 'Backoffice - QualityCare',
        content: 'Administración del sitio web',
      },
    ],
  },
  data() {
    return {
      especialidadesService: null,
      filters: {},
      especialidad: {},
      especialidades: [],
      especialidadDialog: false,
      deleteEspecialidadDialog: false,
      submitted: false,
      deleteEspecialidadesDialog: false,
      selectedEspecialidades: null,
      loading: false,
    };
  },
  created() {
    this.especialidadesService = new EspecialidadesService();
  },
  mounted() {
    this.recuperarEspecialidades();
  },
  methods: {
    recuperarEspecialidades() {
      this.loading = true;
      this.especialidadesService
        .allEspecialidades()
        .then((result) => {
          if (result.data.data) {
            this.especialidades = [...result.data.data];
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error al cargar las especialidades",
            life: 3000,
          });
          this.loading = false;
        });
    },
    toggleEnListado(especialidad, ocultar_en_listado) {
      this.loading = true;
      this.especialidadesService
        .toggleEnListado({ id: especialidad.id, ocultar_en_listado })
        .then(() => {
          especialidad.ocultar_en_listado = ocultar_en_listado;
          this.$set(
            this.especialidades,
            this.findIndexById(especialidad.id),
            especialidad
          );
          this.$toast.add({
            severity: "success",
            summary: "Felicidades",
            detail: `Especialidad ${ocultar_en_listado ? "mostrada" : "ocultada"
              } en listado`,
            life: 3000,
          });
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: `Error al ${ocultar_en_listado ? "mostrar" : "ocultar"
              } la especialidad en listado`,
            life: 3000,
          });
          this.loading = false;
        });
    },
    openNew() {
      this.especialidad = {};
      this.submitted = false;
      this.especialidadDialog = true;
    },
    hideDialog() {
      this.especialidadDialog = false;
      this.submitted = false;
    },
    async saveEspecialidad() {
      this.submitted = true;
      if (this.especialidad.nombre.trim() && this.especialidad.descripcion.trim() && this.especialidad.orden>0) {
        this.loading = true;
        if (this.especialidad.id) {
          //edicion de especialidad
          let idEspecialidadEnEdicion = this.especialidad.id;
          let especialidadEditada = {};
          await this.especialidadesService
            .editarEspecialidad(this.especialidad)
            .then((result) => {
              especialidadEditada = result.data.data;
              this.$set(
                this.especialidades,
                this.findIndexById(idEspecialidadEnEdicion),
                especialidadEditada
              );
              this.$toast.add({
                severity: "success",
                summary: "Felicidades",
                detail: "Especialidad actualizado",
                life: 3000,
              });
            })
            .catch((err) => {
              console.log(err);
            });
          this.loading = false;
        } else {
          //nueva especialidad
          let especialidadCreada = {};
          await this.especialidadesService
            .crearEspecialidad(this.especialidad)
            .then((result) => {
              especialidadCreada = result.data.data;
              this.especialidades.push(especialidadCreada);
              this.$toast.add({
                severity: "success",
                summary: "Felicidades",
                detail: "Especialidad creada",
                life: 3000,
              });
            })
            .catch((err) => {
              console.log(err);
            });
          this.loading = false;
        }
        this.especialidadDialog = false;
        this.especialidad = {};
      }
    },
    editEspecialidad(especialidad) {
      this.especialidad = { ...especialidad };
      this.especialidadDialog = true;
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.especialidades.length; i++) {
        if (this.especialidades[i].id === id) {
          index = i;
          break;
        }
      }
      return index;
    },
    confirmDeleteEspecialidad(especialidad) {
      this.especialidad = especialidad;
      this.deleteEspecialidadDialog = true;
    },
    deleteEspecialidad() {
      this.especialidadesService
        .eliminarEspecialidad({ id: this.especialidad.id })
        .then(() => {
          this.especialidades = this.especialidades.filter(
            (val) => val.id !== this.especialidad.id
          );
          this.deleteEspecialidadDialog = false;
          this.especialidad = {};
          this.$toast.add({
            severity: "success",
            summary: "Felicidades",
            detail: "Especialidad eliminada",
            life: 3000,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.tituloUsuarios {
  font-size: 28px;
  font-weight: 400;
  margin-right: 50px;
}

.muyLargo {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

input[type="file"] {
  display: none;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}

.p-datatable-responsive-demo .p-datatable-tbody>tr>td .p-column-title {
  display: none;
}

@media screen and (max-width: 40em) {
  /deep/ .p-datatable {
    &.p-datatable-responsive-demo {

      .p-datatable-thead>tr>th,
      .p-datatable-tfoot>tr>td {
        display: none !important;
      }

      .p-datatable-tbody>tr>td {
        text-align: left;
        display: block;
        width: 100%;
        float: left;
        clear: left;
        border: 0 none;

        .p-column-title {
          padding: 0.4rem;
          min-width: 30%;
          display: inline-block;
          margin: -0.4em 1em -0.4em -0.4rem;
          font-weight: bold;
        }

        &:last-child {
          border-bottom: 1px solid var(--surface-d);
        }
      }
    }
  }
}
</style>
